module.exports = __webpack_public_path__ + "img/cricket-t20-wc.e3b5f376.png";